import { render, staticRenderFns } from "./CarAccidentDrawer.vue?vue&type=template&id=70dcff33&scoped=true&"
import script from "./CarAccidentDrawer.vue?vue&type=script&lang=js&"
export * from "./CarAccidentDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CarAccidentDrawer.vue?vue&type=style&index=0&id=70dcff33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dcff33",
  null
  
)

export default component.exports